module.exports = __webpack_public_path__ + "static/assets/ff6e94eb50950a0d5b258a5c0eb42062.svg";